import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  mapContainer: {
    height: '100%',
    margin: -theme.spacing(1) * 3,
  },
}));
